import { getAuth, signOut } from "firebase/auth";

function logout() {
    const auth = getAuth();

    if (window.confirm('Are you sure you want to logout?')) {
        signOut(auth)
        window.location.reload();
    }
}

export default logout;